module.exports = __webpack_public_path__ + "static/media/tw-ioc.4668665e.svg";